import { useState } from 'react';

import { ImageModalProps } from './image-modal.component';

const IMAGE_URL_PATTERN = /^https?:\/\/\S+$/i;

export const useImageModal = (props: ImageModalProps) => {
    const [src, setSrc] = useState(props.initialData.src ?? '');
    const [alt, setAlt] = useState(props.initialData.alt ?? '');
    const isValid = IMAGE_URL_PATTERN.test(src.trim()) && alt.trim().length > 0;

    return {
        src,
        setSrc,
        alt,
        setAlt,
        isValid
    };
};
